import { setParams } from "./appSlice";
import store from "./store";

/**
 * @module initializeAppParams
 */
/**
 * Initializes application parameters from the URL's query string.
 * Extracts parameters, removes quotes, and stores them in the Redux store.
 * Cleans up the URL by removing query parameters after extraction.
 * @requires ./appSlice
 * @requires ./store
 * @function
 * @example
 * import { initializeAppParams } from './initializeAppParams';
 * initializeAppParams();
 * // This will extract parameters from the URL and store them in Redux.
 * // If the URL is "http://example.com/?param1=value1&param2=value2",
 * // it will store { param1: 'value1', param2: 'value2'} in the Redux store and clean the URL to "http://example.com/".
 * 
 */
export function initializeAppParams() {
  const searchParams = new URLSearchParams(window.location.search);
  const allParams = {};
  searchParams.forEach((value, key) => {
    allParams[key] = value.replace(/"/g, "");
  });
  store.dispatch(setParams(allParams));

  if (window.location.search) {
    const newUrl = window.location.origin + window.location.pathname + window.location.hash;
    window.history.replaceState({}, "", newUrl);
  }
}
